var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFrente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.26 102.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Form_4",
    "data-name": "Form 4",
    className: "cls-1",
    d: "M36.96,100c-19.57,0-31.69-12.14-31.69-31.69V31.69C5.26,10.66,14.66,0,33.19,0h9.38c4.93.01,9.57,2.33,12.54,6.27l4.27,5.7c1.09,1.44,2.79,2.3,4.6,2.31h13.27c18.84,0,28.01,10.05,28.01,30.72l-.13,23.32c0,19.54-12.13,31.69-31.65,31.69h-36.53ZM15.21,31.69v36.61c0,14.01,7.72,21.74,21.74,21.74h36.53c14,0,21.7-7.73,21.7-21.74l.13-23.31c0-15.32-4.72-20.74-18.06-20.74h-13.26c-4.93-.02-9.56-2.34-12.53-6.27l-4.28-5.71c-1.08-1.44-2.78-2.3-4.58-2.3h-9.38c-12.78.01-17.99,6.3-17.99,21.75v-.03ZM32.69,67.32c-2.75,0-4.97-2.24-4.96-4.99,0-2.48,1.83-4.57,4.28-4.92l.58-.03h45.1c2.75,0,4.98,2.22,4.98,4.97,0,2.49-1.84,4.61-4.31,4.94l-.57.04h-45.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFrente);
export default __webpack_public_path__ + "static/media/logo_frente.15b0b29642e4b87d2bdae44fc6286b9b.svg";
export { ForwardRef as ReactComponent };